import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PositionFundApprovalsTable from './PositionFundApprovalsTable';

function PositionFundApprovals(props) {
    useEffect(() => {}, []);

    return (
        <div className="table__card">
            <PositionFundApprovalsTable
                fetchPositionFundApprovalsUrl={fetchPositionFundApprovalsUrl}
                fetchPositionFundApprovalUrl={fetchPositionFundApprovalUrl}
                updatePositionFundApprovalUrl={updatePositionFundApprovalUrl}
                displayApprovalStatuses={displayApprovalStatuses}
            />
        </div>
    );
}

export default PositionFundApprovals;
if (document.getElementById('PositionFundApprovals')) {
    var rootEl = document.getElementById('PositionFundApprovals');
    ReactDOM.render(
        <App>
            <PositionFundApprovals />
        </App>,
        rootEl,
    );
}
